import * as React from "react";
import {useState} from "react";
import './styles/ProfilePageComponent.scss';
import ProfilePreferCurrencyForm from "../user/ui/ProfilePreferCurrencyForm";
import {MultiFactorAuthProvider, MultiFactorAuthStatus, Settings, UserInfo} from "../http/protocol";
import ProfileMetamapComponent from "./ProfileMetamapComponent";
import NotificationsComponent from "../ui/notifications/NotificationsComponent";
import TokenListComponent from "./TokenListComponent";
import DEFAULT_AVATAR from "../assets/profile_icon.svg";
import {t} from "../i18n";
import ProfileListWithForm from "./ProfileListWithForm";
import {Link} from "react-router-dom";
import {ProfileReceivePromoForm} from "../user/ui/ProfileReceivePromoForm";
import {useSelector} from "react-redux";
import {AppState} from "../RootReducer";
import {journeyHasReceivePromo} from "../selectors/user-selectors";


interface Props {
    settings: Settings;
    user?: UserInfo;
    animate: boolean;
    goBack: () => void;
    minWithdrawValid: boolean;
}



const Avatar = (props: any) => {
    var url = DEFAULT_AVATAR;
    try {
        if (props.settings.pokerEnabled) {
            if (props.user?.avatarUrl) {
                url = props.user.avatarUrl;
                return (
                    <>
                        <img className={"profileAvatar"} src={url} alt={"Profile avatar"} style={{background: `url(${url}) no-repeat`, backgroundSize: 'cover'}}/>
                    </>
                )
            }

        }
    } catch (e) {
        console.error("Failed to get avatar ", e);
    }

    return (
    <div className={"default-avatar"}>
        <i className={"material-icons"}>account_circle</i>
    </div>)

}

const  ProfilePageComponent: React.FC<Props> = ({minWithdrawValid, goBack, animate, user, settings}) => {
    const ua = user && user.attributes ||{};
    const screenNameClass = user && user.attributes && user.attributes.screenName != undefined ? `nameHead haveSet` : `nameHead notSet`;
    const isScreenNameSet = user && user.attributes && user.attributes.screenName ? user.attributes.screenName : t("profile.notSetYet");
    const screenName = user && user.attributes && user.attributes.screenName;

    const [isClickAvatar, setIsClickAvatar] = useState(false);
    const avatarHelpText = isClickAvatar ? `helpText warning showAvatar` : `helpText warning hideAvatar`;

    const reqAtrs = settings.requiredUserAttributes ?? []

    let showReceivePromoSettings = useSelector((app : AppState) => journeyHasReceivePromo(app));

    const ord = (o: number | undefined) => o ?? Number.MAX_VALUE
    reqAtrs.sort((a1, a2) => ord(a1.ordinal) - ord(a2.ordinal))
    const reqAtrComps = reqAtrs
        .filter(a => a.nameTranslationKey)
        .filter(a => a.attributeKey && ua[a.attributeKey])
        .map(a => {
            return (
                <div className={"row account-page-row"}>
                    <div className={"col-md-6"}>
                        <label>{t(a.nameTranslationKey!)}:</label>
                        { a.descriptionTranslationKey  &&
                            <span className={"help"}>{t(a.descriptionTranslationKey)}</span>
                        }
                    </div>
                    <div className={"col-md-6 right"}>
                        <span className={"form-value"}>{ua[a.attributeKey!]}</span>
                    </div>
                </div>
            )
        })




    return (

        <div className={"content-padding"}>
            <div className={"avatar-container"}>
                <Avatar settings={settings} user={user}/>
                {settings.pokerEnabled && !user?.avatarUrl && <span className={"help"}>{t("profile.changeAvatarText")}</span>}
            </div>

            {
                settings.matiEnabled && <ProfileMetamapComponent />
            }

            <h3 className={"section"}><i className={"material-icons"}>account_circle</i> {t("profile.userDetailsTitle")}</h3>

            {   user?.email &&
                <div className={"row account-page-row"}>
                    <div className={"col-md-6"}>
                        <label className={"itemTitle"}>{t("forms.email.label")}:</label>
                    </div>
                    <div className={"col-md-6 right"}>
                        <span className={"form-value"}>{user && user.email}</span>
                    </div>
                </div>
            }

            {   user?.phoneNumber &&
            <div className={"row account-page-row"}>
                <div className={"col-md-6"}>
                    <label className={"itemTitle"}>{t("forms.phoneNumber.label")}:</label>
                </div>
                <div className={"col-md-6 right"}>
                    <span className={"form-value"}>{user && user.phoneNumber}</span>
                </div>
            </div>
            }

            <div className={"row account-page-row"}>
                <div className={"col-md-6"}>
                    <label>{t("profile.userIdTitle")}:</label>
                </div>
                <div className={"col-md-6 right"}>
                    <span className={"form-value"}>{user && user.userUid}</span>
                </div>
            </div>

            {reqAtrComps}

            <ProfileListWithForm value={screenName}
                titleText={t("profile.pokerScreenNameTitle")}
                className={"screenName"}
                helpText={t("forms.screenName.help")}
                helpTextForm={t("profile.screenNameFormHelpText")}
            />




            {settings.mfaEnabled && (
                <>
                    <h4 className={"section"}><i className={`material-icons`}>lock</i> {t("profile.securityTitle")}</h4>

                    <div className={`row account-page-row`}>
                        <div className={"col-md-6"}>
                            <label>{t("profile.security.mfaTitle")}:</label>
                            <span className={"help"}>
                                {t("profile.security.mfaDescription")}
                            </span>
                        </div>
                        <div className={"col-md-6 right"}>
                            {user && user.mfaStatus == MultiFactorAuthStatus.ENABLED && (
                                <span>
                                {user.mfaProvider == MultiFactorAuthProvider.EMAIL && <span>{t("mfa.type.email")}</span>}
                                    {user.mfaProvider == MultiFactorAuthProvider.OTP && <span>{t("mfa.type.app")}</span>}
                            </span>
                            )}
                            {!user || user.mfaStatus != MultiFactorAuthStatus.ENABLED  &&  <Link to={"/profile/2fa"} className={"btn btn-primary small activate2fa"}>{t("profile.security.activateMfa")}</Link>}

                        </div>
                    </div>
                </>
            )}
            <h4 className={"section"}><i className={`material-icons`}>settings</i> {t("profile.settingTitle")}</h4>
            {showReceivePromoSettings && <ProfileReceivePromoForm />}
            <NotificationsComponent />
            {user && user.attributes && <ProfilePreferCurrencyForm
                initialValues={{
                    preferredCurrency: ua.preferredCurrency,
                    preferredCashbackCurrency: ua.preferredCashbackCurrency,
                    preferredPokerExchangeCurrency: ua.preferredPokerExchangeCurrency,
                    preferredFiatExchangeCurrency : ua.preferredFiatExchangeCurrency,
                    displayFiatExchangeIfAvailable : ua.displayFiatExchangeIfAvailable === "true" ? true : false
                }}
                requiredAttributes={settings.requiredUserAttributes}
                userAttributes={user.attributes}
                iconSubmitButton={true} />}


            <TokenListComponent />

        </div>

    )
}

export default ProfilePageComponent;

